var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.009,
    height: 20,
    viewBox: "0 0 20.009 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(0 -0.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40267",
    "data-name": "Path 40267",
    d: "M16.146,1.65H15.4V.9a.781.781,0,0,0-1.562,0V1.65H6.172V.9A.781.781,0,0,0,4.609.9V1.65H3.863A3.867,3.867,0,0,0,0,5.513V16.251a3.867,3.867,0,0,0,3.863,3.863H16.146a3.867,3.867,0,0,0,3.863-3.863V5.513A3.867,3.867,0,0,0,16.146,1.65ZM3.863,3.213h.746V4.736a.781.781,0,0,0,1.563,0V3.213h7.665V4.736a.781.781,0,1,0,1.563,0V3.213h.746a2.3,2.3,0,0,1,2.3,2.3V6.26H1.563V5.513a2.3,2.3,0,0,1,2.3-2.3ZM16.146,18.551H3.863a2.3,2.3,0,0,1-2.3-2.3V7.822H18.446v8.429a2.3,2.3,0,0,1-2.3,2.3ZM6.94,10.9a.781.781,0,0,1-.781.781H4.622a.781.781,0,0,1,0-1.562H6.159A.781.781,0,0,1,6.94,10.9Zm9.228,0a.781.781,0,0,1-.781.781H13.85a.781.781,0,0,1,0-1.562h1.536A.781.781,0,0,1,16.168,10.9Zm-4.618,0a.781.781,0,0,1-.781.781H9.232a.781.781,0,0,1,0-1.562h1.536A.781.781,0,0,1,11.55,10.9ZM6.94,15.5a.781.781,0,0,1-.781.781H4.622a.781.781,0,1,1,0-1.562H6.159A.781.781,0,0,1,6.94,15.5Zm9.228,0a.781.781,0,0,1-.781.781H13.85a.781.781,0,1,1,0-1.562h1.536A.781.781,0,0,1,16.168,15.5Zm-4.618,0a.781.781,0,0,1-.781.781H9.232a.781.781,0,1,1,0-1.562h1.536A.781.781,0,0,1,11.55,15.5Z",
    fill: "#5e6278"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.48f788e0.svg";
export { ForwardRef as ReactComponent };